import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'utcToLocal',
  pure: true,
})
export class UtcToLocalPipe implements PipeTransform {

  private datePipe = new DatePipe('en-US');

  transform(value: any, format: string = 'MMM d, y, h:mm a'): string | null {
    if (!value) return null;

    let utcString = value.toString().trim();

    const hasTimezone =
      utcString.endsWith('Z') ||
      utcString.endsWith('z') ||
      /[+-]\d{2}:\d{2}$/.test(utcString) ||
      /[+-]\d{4}$/.test(utcString);

    if (!hasTimezone) {
      utcString = utcString + 'Z';
    }

    const date = new Date(utcString);

    if (isNaN(date.getTime())) return value;

    return this.datePipe.transform(date, format);
  }
}
